import { render } from "./EventFormScreen.vue?vue&type=template&id=6d91cd9c"
import script from "./EventFormScreen.vue?vue&type=script&lang=js"
export * from "./EventFormScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__